import React from "react"

import { BaseButton, BaseButtonProps } from "./BaseButton"

export type SecondaryButtonProps = {} & Omit<BaseButtonProps, "className">

export const SecondaryButton: React.FC<SecondaryButtonProps> = (props) => (
    <BaseButton {...props} className="secondary" />
)
